import { Component, HostBinding, Input } from '@angular/core';
import { DurationInterface } from '@vendasta/sales-orders';
import { UILineItemWithEditionPricing } from '@vendasta/sales-ui';
import { TaxOption } from '@vendasta/store';

@Component({
  selector: 'orders-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  standalone: false,
})
export class OrderPricingComponent {
  @HostBinding('class') class = 'pricing';

  // TODO loading state
  @Input() orderItems: UILineItemWithEditionPricing[];
  @Input() taxOptions: TaxOption[];
  @Input() duration: DurationInterface;
  @Input() partnerId: string;
  @Input() marketId: string;
}
